export default "__VITE_ASSET__DJHQA5G3__"